import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import T from "i18n";
import globe from "assets/png/icon-globe-white.png";
import globalState from "globalState";
import { CopyrightWrapper, IconWrapper, Medium, Bottom, Links, LinkSection } from "./FooterSectionsSt";

const Wrapper = styled.div`
  a {
    border: none;
  }

  .copyright {    
    display:flex;
    margin: 0;
    font-family: 'EMprint Semibold',Arial,'Helvetica Neue',Helvetica,'Lucida Grande',sans-serif;
    font-size: 12px;
    color: #d4d4d4;
    text-align:left;
    margin-top:10px;

    ${({ theme }) => theme.mediaQueries.medium} {
        justify-content: flex-end;
        text-align:right;
    }
  }
`;

const links = [
  {
    name: "exxon-logo",
    href: "https://www.exxon.com/en",
  },

  {
    name: "mobil-logo",
    href: "https://www.global.mobil.com/en",
  },

  {
    name: "esso-logo",
    href: "https://www.esso.com",
  }
];

const Footer = ({ className }) => {
  const classes = ["Footer"];
  if (className) classes.push(className);
  const state = globalState();

  const locationCopy = T({ path: "footer.selectLocation" });
  const copyrightCopy = T({ path: "copyright.text" });
  const termsText = T({ path: "footer.termsAndConditions.text" });
  const termsLink = T({ path: "footer.termsAndConditions.url" });
  const privacyText = T({ path: "footer.privacyPolicy.text" });
  const privacyLink = T({ path: "footer.privacyPolicy.url" });

  return (
    !state.iframe.get() && (
      <Wrapper className={classes.join(" ")}>
        <Medium>
          <a href="https://corporate.exxonmobil.com/?query=http%3a%2f%2fwww.global.mobil.com%2fen" target="_blank" rel="noreferrer">
            <img src={globe} alt="" />
            {locationCopy}

          </a>
        </Medium>
        <Bottom>
          <IconWrapper>
            <a
              rel="noreferrer"
              className="corporate"
              href="http://corporate.exxonmobil.com"
              target="_blank"
              alt="corporate"
            >
              corporate
            </a>
            <Links list={links} />            
          </IconWrapper>          
          <CopyrightWrapper>               
            <LinkSection>
              <a target="_blank" rel="noreferrer" href={privacyLink}>{privacyText}</a>
              <a target="_blank" rel="noreferrer" href={termsLink}>{termsText}</a>
              <button id="ot-sdk-btn" className="ot-sdk-show-settings" type="button">Privacy center</button>
            </LinkSection>
            <Wrapper className="copyright">
              {copyrightCopy}
            </Wrapper>
          </CopyrightWrapper>
        </Bottom>
      </Wrapper>
    )
  );
};

Footer.displayName = "Footer";

Footer.propTypes = {
  className: PropTypes.string,
};

Footer.defaultProps = {
  className: null,
};

export default Footer;
